import { useCallback } from 'react';

import URLSearchParamsUtils from 'utility/Provide/Url';
import { callApi } from 'utility/Request/callApi';

import { ApiEndpoint } from 'types/Request/endpoint';

export const useDestinationApi = (version = '2_0_0') => {
    const fetchDestinationList = useCallback(
        async (searchTerm: string) => {
            try {
                const queryParams = URLSearchParamsUtils.fromObject({
                    term: searchTerm,
                    v: version,
                });
                const response = await callApi(
                    ApiEndpoint.DestinationAutocompleter,
                    {
                        //url: 'https://urlaub.check24.de/autocompleter', // helpful for testing local
                        queryParams,
                    }
                );

                if (
                    response.parsedBody?.statusmessage === 'success' &&
                    response.parsedBody?.httpstatuscode === 200 &&
                    response.parsedBody?.data
                ) {
                    return response.parsedBody.data;
                }
                return [];
            } catch (error) {
                throw new Error(
                    (error as Record<string, unknown>).message as string
                );
            }
        },
        [version]
    );

    return {
        searchResultProvider: fetchDestinationList,
    };
};
